import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

export const StyledConversationRating = styled.form`
  max-width: 300px;
  display: flex;
  align-items: center;
  position: relative;
  font-size: 12px;
  border: ${(props) => (props.darkTheme ? '0px' : `1px solid ${colors.lightGray21}`)};
  padding: 5px;
  border-radius: 5px;
  margin-right: 10px;
  background: ${(props) => {
    if (props.$isDisabled) {
      return 'none';
    }

    return props.darkTheme ? colors.blue5 : colors.white;
  }};
  height: ${(props) => (props.darkTheme ? '30px' : '25px')};
`;

export const RatingOption = styled.div`
  width: 15px;
  height: 15px;
  margin: 0 5px;
  position: relative;
  top: ${(props) => {
    switch (props.value) {
      case 1:
        return '2px';
      case 5:
        return '-1px';
      default:
        return '0px';
    }
  }};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: ${(props) => {
    switch (props.value) {
      case 1:
        return props.darkTheme
          ? "url('/images/new-designs/thumbs/white-thumb-down.svg')"
          : "url('/images/new-designs/thumbs/black-thumb-down.svg')";
      case 5:
        return props.darkTheme
          ? "url('/images/new-designs/thumbs/white-thumb-up.svg')"
          : "url('/images/new-designs/thumbs/black-thumb-up.svg')";
      default:
        return '';
    }
  }};

  cursor: pointer;
`;

/* Global styles */
export const StyledDropdownNode = styled.fieldset`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${colors.baseText};
  font-size: 9px;
  padding: 18px;
  padding-top: 0px;

  &.disabled {
    border-bottom: 1px solid ${colors.lightGray15};
  }

  .line {
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    label {
      margin: 0;
      cursor: pointer;
      text-align: left;
    }
  }

  h3 {
    font-family: 'Lato-Bold';
    font-size: 13px;
    font-weight: 900;
    color: ${colors.baseText};
    margin: 18px 0 8px;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  input[type='checkbox'],
  input[type='radio'] {
    margin: 0 9px 0 0;
    appearance: none;
    width: 10px;
    height: 10px;
    border-radius: 2px;
    background-image: url('/images/checkbox/Checkbox_Inactive.svg');
    background-size: cover;
    background-color: ${colors.white};
    outline: none !important;

    &:checked {
      background-image: url('/images/checkbox/Checkbox_Active.svg');

      &:disabled {
        background-image: url('/images/checkbox/Checkbox_GrayedOut.svg');
      }
    }
  }

  textarea {
    width: 100%;
    min-height: 75px;
    resize: vertical;
    max-height: 300px;
    border: solid 0.8px ${colors.lightGray21};
    background-color: ${colors.white};
    border-radius: 5px;
    outline: none;
    padding: 7px;

    &:focus {
      border: solid 0.8px ${colors.blue7};
    }
  }
`;
